import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.6866 17.5C34.6866 27.165 26.9217 35 17.3433 35C7.76485 35 0 27.165 0 17.5C0 7.83502 7.76485 0 17.3433 0C26.9217 0 34.6866 7.83502 34.6866 17.5Z"
        fill="#0088FF"
      />
      <path
        d="M23.75 9.425L22.5 8L21.25 9.425L20 8L18.75 9.425L17.5 8L16.25 9.425L15 8L13.75 9.425L12.5 8L11.25 9.425L10 8V27L11.25 25.575L12.5 27L13.75 25.575L15 27L16.25 25.575L17.5 27L18.75 25.575L20 27L21.25 25.575L22.5 27L23.75 25.575L25 27V8L23.75 9.425ZM23.3333 24.2355H11.6667V10.7645H23.3333V24.2355ZM12.5 20.35H22.5V22.25H12.5V20.35ZM12.5 16.55H22.5V18.45H12.5V16.55ZM12.5 12.75H22.5V14.65H12.5V12.75Z"
        fill="white"
      />
    </svg>
  );
};
